// src/services/password.js
import http from '../lib/http';

export const forgotRequest = (email) => {
  const f = new FormData();
  f.append('email', email);
  return http.post('/api/customer/forgot-password/request', f);
};

export const forgotVerifyOtp = (email, otp) => {
  const f = new FormData();
  f.append('email', email);
  f.append('otp', otp);
  return http.post('/api/customer/forgot-password/verify-otp', f);
};

export const resetPassword = (email, password, password_confirmation) => {
  const f = new FormData();
  f.append('email', email);
  f.append('password', password);
  f.append('password_confirmation', password_confirmation);
  return http.post('/api/customer/forgot-password/reset', f);
};
